module.exports = __webpack_public_path__ + "media/images/button_PlayNextLg-7dc847187f2923f3bc8b9f7e0fbe897a.png";